<h1 mat-dialog-title> {{ 'internalEquipment.dialog.performance.status.title' | translate }}</h1>
<form class="calibrates-theme">
    <div fxLayout="column" fxLayout.xs="column" class="flexwrap">
        <div fxFlex="100">
            <span> {{ 'internalEquipment.dialog.performance.status.label' | translate }}</span>
        </div>
        @for (performance of data.performances; track performance;) {
        <div fxFlex="100">
            <mat-checkbox (change)="onPerformanceSelectChange(performance.idActionType, $event)"
                style="margin-left: 1em;">
                {{ showPerformances(performance.idActionType) }}
            </mat-checkbox>
        </div>
        }
    </div>

    <div mat-dialog-actions class="calibrates-theme">
        <div fxFlex></div>
        <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.save' | translate
            }}</button>
        <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
    </div>
</form>